import React from "react";

const UnKnownRoutes = () => {
  return (
    <div>
      <h1 className="text-4xl text-center">404 Paoa jassena</h1>
    </div>
  );
};

export default UnKnownRoutes;
